import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Emergency } from './emergency.model';
import emergencyService from './emergency.service';

// namespace
export const EMERGENCY_STORE_NAMESPACE = 'emergencyStore';

// state
interface EmergencyState {
  emergencies: Emergency[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: EmergencyState = {
  emergencies: [],
  status: 'init',
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<EmergencyState> = {
  [mutationConstant.FETCH]: (state: EmergencyState, emergencies: Emergency[]) => {
    state.emergencies = emergencies;
  },
  [mutationConstant.PENDING]: (state: EmergencyState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: EmergencyState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: EmergencyState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
};

const action: ActionTree<EmergencyState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<EmergencyState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      emergencyService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_TYPE: 'byType',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<EmergencyState, RootState> = {
  [getterConstant.ALL]: (state: EmergencyState) => state.emergencies,
  [getterConstant.BY_TYPE]: (state: EmergencyState) => (typeId: number, provinceId: number, startDate: Date, endDate: Date) => state.emergencies.filter(m =>
    m.emergencyType.id === typeId &&
    m.emergencyDate >= startDate && m.emergencyDate <= endDate &&
    m.province.id === provinceId),
  [getterConstant.BY_ID]: (state: EmergencyState) => (id: number) => state.emergencies.find(m => m.id === id),
  [getterConstant.STATUS]: (state: EmergencyState) => state.status,
};

// module
const module: Module<EmergencyState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const EmergencyGetter = {
  ALL: `${EMERGENCY_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_TYPE: `${EMERGENCY_STORE_NAMESPACE}/${getterConstant.BY_TYPE}`,
  BY_ID: `${EMERGENCY_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${EMERGENCY_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const EmergencyAction = {
  FETCH: `${EMERGENCY_STORE_NAMESPACE}/${actionConstant.FETCH}`,
};

export default module;
